var $ = require('jquery')

const DEFAULT_PREFECTURE_NAME = '指定なし'
const DEFAULT_CITY_NAME = '指定なし'

$(() => {
  $('.select-prefectures').on('change', function () {
    const selected = $(this).children('option:selected').text()
    const api_path = '/api/prefecture/' + selected + '/cities'
    const select_cities_class = '.select-cities'
    send_api(selected, api_path, select_cities_class)
  })

  $('.select-prefectures-enable').on('change', function () {
    const selected = $(this).children('option:selected').text()
    const api_path = '/api/prefecture/' + selected + '/enable_cities'
    const select_cities_class = '.select-cities-enable'
    send_api(selected, api_path, select_cities_class)
  })

  const send_api = function (selected, api_path, select_cities_class) {
    if (selected === DEFAULT_PREFECTURE_NAME) {
      remove_selected_cities(select_cities_class)
      return
    }

    $.ajax({
      url: api_path,
      method: 'GET',
      data: 'json',
      error: function (xhr, status, error) {
        console.error('AJAX Error: ' + status + ' / ' + error)
      },
      success: function (response) {
        build_cities_select_box(select_cities_class, response)
      }
    })
  }

  const build_cities_select_box = function (select_cities_class, response) {
    remove_selected_cities(select_cities_class)
    $.each(response, function () {
      $(select_cities_class).append(
        $('<option>').html(this.name).val(this.id)
      )
    })
  }

  const remove_selected_cities = function (select_cities_class) {
    $(select_cities_class + ' > option').remove()
    $(select_cities_class).append(
      $('<option>').html(DEFAULT_CITY_NAME).val(null)
    )
  }
})
